import { objectEntries } from 'ts-extras'

import { useIsMinWidth2xl } from '@/hooks/useIsMinWidth2xl'
import { useIsMinWidthLg } from '@/hooks/useIsMinWidthLg'
import { useIsMinWidthMd } from '@/hooks/useIsMinWidthMd'
import { useIsMinWidthXl } from '@/hooks/useIsMinWidthXl'
import { Breakpoint } from '@/types/misc'

export function useIsBreakpoint(breakpoint: Breakpoint) {
  const isMinWidth2xl = useIsMinWidth2xl()
  const isMinWidthXl = useIsMinWidthXl()
  const isMinWidthLg = useIsMinWidthLg()
  const isMinWidthMd = useIsMinWidthMd()

  const breakpoints: Record<Breakpoint, boolean> = {
    '2xl': isMinWidth2xl,
    xl: isMinWidthXl,
    lg: isMinWidthLg,
    md: isMinWidthMd,
    sm: true, // If we're not on the other breakpoints, we must be on `sm`
  }

  const activeBreakpoint = objectEntries(breakpoints).find(
    ([_breakpoint, isActive]) => isActive,
  )

  if (!activeBreakpoint) {
    throw new Error('Failed to determine active breakpoint')
  }

  return breakpoint === activeBreakpoint[0]
}
